import { CollectionViewHeroSection, CollectionViewSection } from './types'

export function isCollectionGridSection(
  section: CollectionViewSection
): section is Extract<CollectionViewSection, { __typename: 'CollectionGridSection' }> {
  return section.__typename === 'CollectionGridSection'
}

export function isCollectionViewHeroSection(
  section: CollectionViewSection
): section is CollectionViewHeroSection {
  return section.__typename === 'CollectionViewHeroSection'
}
